// components/PricingSection.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function PricingSection() {
    return (
        <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
                        Simple, Transparent Pricing — VAT Inclusive
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        Choose the plan that fits your business today. Upgrade or downgrade anytime.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
                    {/* Basic Plan */}
                    <div className="border rounded-2xl p-8 shadow-lg hover:shadow-xl transition">
                        <h3 className="text-2xl font-bold mb-4">Basic</h3>
                        {/* <div className="mb-6">
                            <span className="text-4xl font-bold">₦45,000</span>
                            <span className="text-gray-600">/month</span>
                        </div>
                        <div className="text-sm text-gray-500 mb-6">
                            or ₦540,000 annually
                        </div> */}
                        <ul className="space-y-3 mb-8 text-gray-700">
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> Point of Sale & Invoicing</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> Inventory & Sales Management</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> Supplier & Credit Management</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> Full Accounting & Reports</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> 1 Business • Up to 6 Users</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> 1,000 transactions/month</li>
                        </ul>
                        <Link to="/start">
                            <button className="w-full py-3 bg-[#4285F4] text-white font-semibold rounded-lg hover:bg-indigo-700 transition">
                                Start Free Trial
                            </button>
                        </Link>
                    </div>

                    {/* Standard Plan - Highlighted */}
                    <div className="border-2 border-[#4285F4] rounded-2xl p-8 shadow-2xl relative transform scale-105">
                        <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-[#4285F4] text-white px-4 py-1 rounded-full text-sm font-semibold">
                            Most Popular
                        </div>
                        <h3 className="text-2xl font-bold mb-4">Standard</h3>
                        {/* <div className="mb-6">
                            <span className="text-4xl font-bold">₦100,000</span>
                            <span className="text-gray-600">/month</span>
                        </div>
                        <div className="text-sm text-gray-500 mb-6">
                            or ₦1,200,000 annually
                        </div> */}
                        <ul className="space-y-3 mb-8 text-gray-700">
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> Everything in Basic</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> AI Chatbot for Financial Insights</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> Multi-Currency & Multi-Location</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> Custom Analytics Dashboard</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> Up to 5 Businesses • 200 Users</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> 5,000 transactions/month</li>
                        </ul>
                        <Link to="/start">
                            <button className="w-full py-3 bg-[#4285F4] text-white font-semibold rounded-lg hover:bg-indigo-700 transition">
                                Start Free Trial
                            </button>
                        </Link>
                    </div>

                    {/* Enterprise Plan */}
                    <div className="border rounded-2xl p-8 shadow-lg hover:shadow-xl transition">
                        <h3 className="text-2xl font-bold mb-4">Enterprise</h3>
                        {/* <div className="mb-6">
                            <span className="text-4xl font-bold">₦500,000</span>
                            <span className="text-gray-600">/month</span>
                        </div>
                        <div className="text-sm text-gray-500 mb-6">
                            or ₦6,000,000 annually
                        </div> */}
                        <ul className="space-y-3 mb-8 text-gray-700">
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> All Standard Features</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> Multiple Businesses & Users</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> Custom API & Data Pipelines</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> External System Integrations</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> White-Label Option</li>
                            <li className="flex items-start"><span className="text-green-500 mr-2">✓</span> Dedicated Account & Tech Support</li>
                        </ul>
                        <Link to="contact-sales">
                            <button className="w-full py-3 bg-[#4285F4] text-white font-semibold rounded-lg hover:bg-indigo-700 transition">
                                Contact Sales
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}